import { BfxBlotterOrdersContextMenuActionPayload } from "./BfxBlotterOrdersContextMenuActionPayload";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";
import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../ContextMenuState";

import { TraderGroupPromiseLookupService } from "../../../lookup/model/impl/TraderGroupPromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxBlotterOrdersContextMenuItemAcceptanceState extends ContextMenuItemState {
  public actionRequests: BfxBlotterOrdersContextMenuActionPayload;
  public callOrderRateSide?: CubiqTS.RateSideType = null;
  public queryCallOrderRateSide?: boolean = false;

  // copy from menu state
  public warnings = {
    show: false,
    warning_count: 0,
    external: {
      display: false,
      ids: [],
    },
  };

  constructor(
    count: number = 0,
    itemIndex: number = 0,
    available: boolean = false,
    enabled: boolean = false,
    title: string = "",
  ) {
    super(count, itemIndex, available, enabled, title);
  }
}
